(function () {

    'use strict';

    angular.module('Services').factory('NonManifestsTableService', NonManifestsTableService);

    NonManifestsTableService.$inject = [
        'Shipments', 
        'Carrier', 
        'TableLiteFactory', 
        '$filter', 
        'toastr', 
        '$q',
        'ClientService'
    ];

    function NonManifestsTableService(
        Shipments, 
        Carrier, 
        TableLiteFactory, 
        $filter, 
        toastr, 
        $q,
        ClientService
    ) {
        return function () {
            let defaultFilters = {};
            let presetfilter = angular.fromJson(localStorage.getItem('shipmentsFilter')) || {};
            localStorage.removeItem('shipmentsFilter');
            if (presetfilter) {
                defaultFilters = angular.copy(presetfilter);
            }

            presetfilter.carrierProfile = angular.getObjVal(presetfilter, 'carrierProfile.id');

            const bookingStatuses = {
                inprogress: 'Processing',
                processed: 'Completed',
                pending: 'Awaiting Booking'
            };
            let ShipmentsTableData = {
                tableName: 'NonManifestedShipmentsSearchTable',
                /*optionAddOns: {
                    buttons: [{
                        class: 'btn-primary',
                        label: '+ ADD NEW',
                        onClick: function () {

                        }
                    }]
                },*/
                config: {
                    noPagination: false,
                    noHeaders: false,
                    noItemsView: false,
                    noTableFooter: false,
                    noExtraction: true,
                    colMinWidth: '135px'
                },
                headers: [{
                    label: 'Booking Date',
                    viewName: 'bookingDateFormatted',
                    filterName: 'bookingDate',
                    filter: {
                        type: 'datePicker',
                        url: '',
                        class: 'filter-date',
                        toModel: defaultFilters.createdDate ? new Date(defaultFilters.createdDate[0]) : '',
                        fromModel: defaultFilters.createdDate ? new Date(defaultFilters.createdDate[1]) : '',
                        onSubmit: function (header) {

                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                            //sendRequest();
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'SCHEDULED PICK-UP',
                    viewName: 'scheduledPickup',
                    fitlerName: 'pickupDetails.pickupDate',
                    filter: {
                        type: 'datePicker',
                        url: '/templates/directives/intellectual-table/filters-cells/datePicker2.html',
                        class: 'filter-date',
                        toModel: defaultFilters.scheduledPickup ? new Date(defaultFilters.scheduledPickup[0]) : '',
                        fromModel: defaultFilters.scheduledPickup ? new Date(defaultFilters.scheduledPickup[1]) : '',
                        onSubmit: function(header){
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function(){
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'PICK-UP EARLIEST TIME',
                    viewName: 'pickupEarliestTime',
                    filterName: 'pickupDetails.pickupEarliestTime',
                    headerFn: function(){
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'Hours since booked',
                    viewName: 'hoursSinceBooked',
                    filterName: 'createdDate',
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'CONSIGNMENT NO.',
                    viewName: 'consignmentId',
                    filterName: 'consignmentId',
                    filter: {
                        type: 'text',
                        class: 'filter-consignment-no',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'Company',
                    viewName: 'companyName',
                    filterName: "companyId",
                    filter: {
                        type: 'autoComplete',
                        placeholder: 'Search',
                        viewName: 'name',
                        filterBy: 'id',
                        items: [],
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        },
                        refresh: function (model) {
                            const defer = $q.defer();
                            ClientService.Company.getAll(res => {
                                this.items = res.content;
                                defer.resolve();
                            }, error => {
                                console.log(error);
                                defer.reject();
                            }, {name: model});
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: ' Office/Location',
                    viewName: 'locationName',
                    filterName: 'officeName',
                    filter: {
                        type: 'text',
                        class: 'filter-company',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'Account',
                    viewName: 'accountEmail',
                    filterName: 'userEmail',
                    filter: {
                        type: 'text',
                        class: 'filter-account',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'THIRD PARTY REFERENCE NO.',
                    viewName: 'wmsReference',
                    filterName: 'wmsReference',
                    filter: {
                        type: 'text',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'CUSTOMER REF NO.',
                    viewName: 'customerReferences',
                    filterName: 'customerReferences',
                    filter: {
                        type: 'text',
                        class: 'filter-customer-ref',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'Linked Job',
                    viewName: 'jobId',
                    filterName: 'job.id',
                    filter: {
                        type: 'text',
                        class: 'filter-customer-ref',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'CARRIER PROFILE',
                    viewName: 'carrierProfileName',
                    filterName: 'carrierProfileId',
                    sortName: 'carrierProfile.id',
                    filter: {
                        type: 'autoComplete',
                        placeholder: 'Search',
                        viewName: 'name',
                        model: defaultFilters?defaultFilters.carrierProfile : '',
                        filterBy: 'id',
                        items: [],
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        },
                        refresh: function (model) {
                            const defer = $q.defer();
                            let filterItems = this.items;
                            Carrier.carrierProfilesCompact((data) => {
                                filterItems.length = 0;
                                angular.forEach(data.content, (profile) => {
                                    filterItems.push(profile);
                                });
                                filterItems.sort((a, b) => a.name.localeCompare(b.name));
                                defer.resolve();
                            }, (error) => {
                                defer.reject();
                            }, {size: 10, name: model});
                            return defer.promise;
                        }
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                }, {
                    label: 'SERVICE PROFILE',
                    viewName: 'serviceProfileName',//to fix
                    filterName: 'serviceProfileId',//to fix
                    filter: {
                        type: 'autoComplete',
                        placeholder: 'Search',
                        viewName: 'displayName',
                        filterBy: 'id',
                        items: [], //List of items shown in dropdown
                        onSubmit: function (header) {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        },
                        refresh: function (model) {
                            const defer = $q.defer();
                            let filterItems = this.items;
                            Carrier.serviceProfilesCompact((data) => {
                                filterItems.length = 0;
                                angular.forEach(data.content, (profile) => {
                                    filterItems.push(profile);
                                });
                                filterItems.sort((a, b) => a.name.localeCompare(b.name));
                                defer.resolve();
                            }, (error) => {
                                defer.reject();
                            }, {
                                size: 10,
                                name: model,
                                carrierProfileId: tableActions.activeFilters.carrierProfileId
                            });
                            return defer.promise;
                        }
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                }, {
                    label: 'DESTINATION ADDRESS',
                    viewName: 'destinationAddress'
                }, {
                    label: 'AMOUNT EX TAX',
                    viewName: 'amount'
                }],
                data: [],
                extractTable: function (form) {

                },
                resetFilters: () => {
                    tableActions.resetFilters();
                },
                onInit: function () {
                    tableActions.sendRequest({});
                }
            };
            const tableActions = new TableLiteFactory(ShipmentsTableData,
                {
                    serviceCallback: Shipments.getNonManifested,
                    callbackFormat: ['success', 'error', 'filter'],
                    postRequestCallback: data => {
                        buildTableData(data);
                    },
                    postRequestErrorCallback: err => {
                        buildTableData(null);
                        toastr.error(err);
                    },
                    defaultFilters: angular.extend({
                        size: 20,
                        page: 0,
                        sort: 'bookingDate,asc'
                    }, presetfilter)
                }
            );

            function hoursDifference(day1, day2) {
                let differenceStr = '';
                let dayMS = 24 * 60 * 60 * 1000;
                let firstDate = new Date(day1);
                let secondDate = new Date(day2);
                let diffDays = Math.abs((firstDate.getTime() - secondDate.getTime()) / (dayMS));
                let remHrs = Math.abs((diffDays - Math.floor(diffDays)) * 24);

                if (Math.floor(diffDays))
                    differenceStr += Math.floor(diffDays) + ' Day(s) ';
                if (Math.floor(remHrs))
                    differenceStr += Math.floor(remHrs) + ' Hour(s)';

                return differenceStr;
            }

            function buildTableData(data) {
                /*** START - Building of Data ***/

                if (!data)
                    return ShipmentsTableData;
                tableActions.initializeTableData(data);
                angular.forEach(data.content, function (item) {
                    item.bookingDateFormatted = $filter('bbaDate')(item.bookingDate);
                    item.hoursSinceBooked = item.bookingDate ? hoursDifference(new Date(), new Date(item.bookingDate)) : 'N/A';
                    item.companyName = angular.getObjVal(item, 'company.name') || 'N/A';
                    item.consignmentId = item.consignmentId || 'N/A';
                    item.locationName = angular.getObjVal(item, 'office.name') || 'N/A';
                    item.accountEmail = angular.getObjVal(item, 'user.email') || 'N/A';
                    item.carrierProfileName = angular.getObjVal(item, 'serviceProfile.carrierProfile.name') || 'N/A';
                    item.serviceProfileName = angular.getObjVal(item, 'serviceProfile.name') || 'N/A';
                    item.jobId = angular.getObjVal(item, 'job.jobId') || 'N/A';
                    item.wmsReference = item.wmsReference || 'N/A';
                    if (item.serviceDetails) {
                        item.carrierName = {
                            type: 'logotype',
                            imgSrc: item.serviceDetails.logo
                        };
                        item.serviceName = item.serviceDetails.serviceName || 'N/A';
                    }
                    item.amount = Shipments.getShipmentCostFormatted(item).amountFormatted;
                    item.bookingStatus = bookingStatuses[item.bookingStatus] || 'N/A'; // Define Bo oking Status
                    item.customerReferences = (item.customerReferences || []).join(', ') || 'N/A'; // Join Multiple Customer Refs in One

                    item.scheduledPickup = angular.getObjVal(item, 'pickupDetails.pickupDate') ?  $filter('bbaDate')(item.pickupDetails.pickupDate) : 'N/A';
                    item.pickupEarliestTime = angular.getObjVal(item, 'pickupDetails.pickupEarliestTime') || 'N/A';

                    let fullAddress = 'N/A';

                    if (item.destinationAddress) {
                        fullAddress = item.destinationAddress.addressLine1;

                        if (item.destinationAddress.addressLine2) {
                            fullAddress = item.destinationAddress.addressLine1 + ' ' + item.destinationAddress.addressLine2;
                        }

                        if (item.destinationAddress.location) {
                            fullAddress = fullAddress + ', ' + item.destinationAddress.location.name;

                            if (item.destinationAddress.location.state) {
                                fullAddress = fullAddress + ', ' + item.destinationAddress.location.state.name;
                            }

                            fullAddress = fullAddress + ', ' + item.destinationAddress.location.country.name + ', ' + item.destinationAddress.location.code;
                        }
                    }
                    item.destinationAddress = fullAddress;

                    item.href = '/shipments/view/' + item.id;
                    ShipmentsTableData.data.push(item);
                });
            }

            this.tableData = ShipmentsTableData;
        }
    }
})();



// WEBPACK FOOTER //
// ./js/services/tables/NonManifestsTableService.js